const ETHOS_IMAGE_DURATION = 600;
const ETHOS_TEXT_DURATION = 200;
const ETHOS_TEXT_OFFSET = '10px';

/**
 * Ethos / featured-projects carousel.
 *
 * A list of labels that crossfades a stacked image (clip-path wipe) and swaps the
 * descriptive text. If a "Read more" link ([data-slide-link]) is present, its href
 * is updated to the active slide's URL (each trigger carries data-link) — used by
 * the framework featured-projects variant; a harmless no-op on the homepage where
 * no link exists.
 *
 * Shared by routes/templateHome.js and routes/templateFramework.js.
 */
export default function initEthosCarousels(root = document) {
    root.querySelectorAll('.js-ethos-carousel').forEach((section) => {
        const triggers = Array.from(section.querySelectorAll('[data-index]'));
        const images = Array.from(section.querySelectorAll('[data-image]'));
        const textEl = section.querySelector('[data-slide-text]');
        const linkEl = section.querySelector('[data-slide-link]');
        if (!triggers.length || !images.length || !textEl) return;

        let current = 0;
        let busy = false;

        const setTriggerState = (nextIndex) => {
            triggers.forEach((btn, i) => {
                const active = i === nextIndex;
                btn.classList.toggle('text-brand-emerald', active);
                btn.classList.toggle('text-brand-blush', !active);
                btn.classList.toggle('hover:text-brand-dew', !active);
            });
        };

        const resetImage = (el, z) => {
            el.style.transition = 'none';
            el.style.clipPath = 'inset(0 0 0 0)';
            el.style.zIndex = String(z);
            void el.offsetWidth; // flush so next transition starts from here
        };

        const go = (next) => {
            if (busy || next === current || next < 0 || next >= triggers.length) return;
            busy = true;

            setTriggerState(next);

            const outgoing = images[current];
            const incoming = images[next];

            // Incoming sits directly underneath the outgoing image, fully visible.
            resetImage(incoming, 2);
            // Outgoing stays on top while it wipes away to reveal incoming.
            resetImage(outgoing, 3);

            // Wipe outgoing downward: clip from the top until the image is gone.
            outgoing.style.transition = `clip-path ${ETHOS_IMAGE_DURATION}ms ease-in-out`;
            outgoing.style.clipPath = 'inset(100% 0 0 0)';

            // Text: slide down + fade out, swap content, then slide up + fade in.
            const newText = triggers[next].dataset.text || '';
            const newLink = triggers[next].dataset.link || '';
            textEl.style.opacity = '0';
            textEl.style.transform = `translateY(${ETHOS_TEXT_OFFSET})`;
            window.setTimeout(() => {
                textEl.textContent = newText;
                if (linkEl && newLink) linkEl.href = newLink;
                textEl.style.opacity = '1';
                textEl.style.transform = 'translateY(0)';
            }, ETHOS_TEXT_DURATION);

            // After the wipe finishes, reset all images to a clean baseline.
            window.setTimeout(() => {
                resetImage(outgoing, 1);
                incoming.style.zIndex = '2';
                current = next;
                busy = false;
            }, ETHOS_IMAGE_DURATION);
        };

        triggers.forEach((btn) => {
            btn.addEventListener('click', () => go(Number(btn.dataset.index)));
        });
    });
}
